export enum ResidentValidateTransmitterResultType {
  Valid = 'Valid',
  IncorrectExternalIdFormat = 'IncorrectExternalIdFormat',
  AlreadyExistsNotLinked = 'AlreadyExistsNotLinked',
  AlreadyExistsLinkedToResidentSameLocation = 'AlreadyExistsLinkedToResidentSameLocation',
  AlreadyExistsLinkedToResidentOtherLocation = 'AlreadyExistsLinkedToResidentOtherLocation',
  Unknown = 'Unknown',
}
